define("settings/templates/groups/group/contributors", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    <section class="tAC--section u--m__t__lg">
    <div class="tAC--section__item">
      <div class="tAC--section__detail">
        <h3 class="u--m__b__xs u--m__t__0">
          {{t "shared_words.contributors"}}
        </h3>
        <p class="u--text--md u--m__0 u--p__r__lg">
          {{t "account.groups.group.contributors.description"}}
        </p>
      </div>
      <div class="tAC--section__action">
        <LinkTo @route="groups.group.contributors.new" class="o--btn o--btn--primary u--float--right">
          {{t "shared_phrases.invite_contributor"}}
        </LinkTo>
      </div>
    </div>
  </section>
  <section class="tAC--section">
    <table class="o--table o--table--hover tAC--table">
      <thead>
        <tr>
          <th class="u--text--left">
            {{t "shared_words.name"}}
          </th>
          <th class="u--text--left">
            {{t "shared_words.email"}}
          </th>
          <th class="u--text--left">
            {{t "contributors.status"}}
          </th>
          <th class="u--text--left">
            {{t "shared_words.actions"}}
          </th>
        </tr>
      </thead>
      <tbody>
        {{#each
          (sort-by "invited" "name" (filter-by "group.id" this.group.id (filter-by "isContributor" true @model)))
          as |contributorMembership|
        }}
          <tr class="u--text--md dd-privacy-mask-user-input">
            <td>
              {{contributorMembership.user.name}}
            </td>
            <td>
              {{contributorMembership.user.email}}
            </td>
            <td>
              <div class="tCO--table__status">
                {{#if contributorMembership.invited}}
                  {{t "contributors.pending"}}
                {{else}}
                  {{svg-jar "verified" class="o--icon o--icon--success"}}
                  {{t "contributors.accepted"}}
                {{/if}}
              </div>
            </td>
            <td>
              <Shared::Ui::Button
                @onClick={{perform this.removeContributor contributorMembership}}
                @text={{t "shared_words.remove"}}
                @variant="outline"
              />
            </td>
          </tr>
        {{else}}
          <tr>
            <td colspan="3">
              <p class="o--blank">
                {{t "account.groups.group.contributors.empty"}}
              </p>
            </td>
          </tr>
        {{/each}}
      </tbody>
    </table>
  </section>
  {{outlet}}
  */
  {
    "id": "Yjv9Pzsg",
    "block": "[[[10,\"section\"],[14,0,\"tAC--section u--m__t__lg\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"tAC--section__item\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"tAC--section__detail\"],[12],[1,\"\\n      \"],[10,\"h3\"],[14,0,\"u--m__b__xs u--m__t__0\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"shared_words.contributors\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--text--md u--m__0 u--p__r__lg\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"account.groups.group.contributors.description\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"tAC--section__action\"],[12],[1,\"\\n      \"],[8,[39,1],[[24,0,\"o--btn o--btn--primary u--float--right\"]],[[\"@route\"],[\"groups.group.contributors.new\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,0],[\"shared_phrases.invite_contributor\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"],[10,\"section\"],[14,0,\"tAC--section\"],[12],[1,\"\\n  \"],[10,\"table\"],[14,0,\"o--table o--table--hover tAC--table\"],[12],[1,\"\\n    \"],[10,\"thead\"],[12],[1,\"\\n      \"],[10,\"tr\"],[12],[1,\"\\n        \"],[10,\"th\"],[14,0,\"u--text--left\"],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"shared_words.name\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"th\"],[14,0,\"u--text--left\"],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"shared_words.email\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"th\"],[14,0,\"u--text--left\"],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"contributors.status\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"th\"],[14,0,\"u--text--left\"],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"shared_words.actions\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,\"tbody\"],[12],[1,\"\\n\"],[42,[28,[37,3],[[28,[37,3],[[28,[37,4],[\"invited\",\"name\",[28,[37,5],[\"group.id\",[30,0,[\"group\",\"id\"]],[28,[37,5],[\"isContributor\",true,[30,1]],null]],null]],null]],null]],null],null,[[[1,\"        \"],[10,\"tr\"],[14,0,\"u--text--md dd-privacy-mask-user-input\"],[12],[1,\"\\n          \"],[10,\"td\"],[12],[1,\"\\n            \"],[1,[30,2,[\"user\",\"name\"]]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"td\"],[12],[1,\"\\n            \"],[1,[30,2,[\"user\",\"email\"]]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"td\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"tCO--table__status\"],[12],[1,\"\\n\"],[41,[30,2,[\"invited\"]],[[[1,\"                \"],[1,[28,[35,0],[\"contributors.pending\"],null]],[1,\"\\n\"]],[]],[[[1,\"                \"],[1,[28,[35,7],[\"verified\"],[[\"class\"],[\"o--icon o--icon--success\"]]]],[1,\"\\n                \"],[1,[28,[35,0],[\"contributors.accepted\"],null]],[1,\"\\n\"]],[]]],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"td\"],[12],[1,\"\\n            \"],[8,[39,8],null,[[\"@onClick\",\"@text\",\"@variant\"],[[28,[37,9],[[30,0,[\"removeContributor\"]],[30,2]],null],[28,[37,0],[\"shared_words.remove\"],null],\"outline\"]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[2]],[[[1,\"        \"],[10,\"tr\"],[12],[1,\"\\n          \"],[10,\"td\"],[14,\"colspan\",\"3\"],[12],[1,\"\\n            \"],[10,2],[14,0,\"o--blank\"],[12],[1,\"\\n              \"],[1,[28,[35,0],[\"account.groups.group.contributors.empty\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"],[46,[28,[37,11],null,null],null,null,null]],[\"@model\",\"contributorMembership\"],false,[\"t\",\"link-to\",\"each\",\"-track-array\",\"sort-by\",\"filter-by\",\"if\",\"svg-jar\",\"shared/ui/button\",\"perform\",\"component\",\"-outlet\"]]",
    "moduleName": "settings/templates/groups/group/contributors.hbs",
    "isStrictMode": false
  });
});